import { render } from "./_recipient-filter.vue?vue&type=template&id=630e7702&lang=pug"
import script from "./_recipient-filter.vue?vue&type=script&lang=js"
export * from "./_recipient-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__